import Icon from "../Elements/Icon";

export default {
  components: { Icon },
  props: {
    fill: {
      type: String,
      default: "currentColor"
    }
  }
}